import styled from "styled-components";

export const PreviewImage = styled.img`
  width: 150px;
  height: 150px;
  object-fit: contain;
`;
